import React, { useState, Fragment, useEffect } from "react";
import {
    Card,
    CardBody,
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    Button,
} from "reactstrap";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import Swal from "sweetalert2";
import api from '../../../api';

const MappingPromptScreen: React.FC = () => {
    const [systemPrompt, setSystemPrompt] = useState("");
    const [loading, setLoading] = useState(false);

    // Fetch prompt from backend
    useEffect(() => {
        const fetchPrompts = async () => {
            try {
                const response = await api.fetch("api/prompt/get-prompts-data");
                if (!response.ok) throw new Error("Failed to fetch prompt data");

                const data = await response.json();
                if (data && data.system_prompt) {
                    setSystemPrompt(data.system_prompt);
                }
            } catch (error) {
                console.error("Error fetching prompts:", error);
            }
        };

        fetchPrompts();
    }, []);

    // Save prompt
    const handleSave = async () => {
        try {
            setLoading(true);
            const payload = {
                system_prompt: systemPrompt
            };

            const res = await api.fetch("api/Prompt", {
                method: "POST",
                body: JSON.stringify(payload)
            });

            if (!res.ok) throw new Error("Failed to save");
            setLoading(false);
            Swal.fire({
                icon: "success",
                title: "Saved",
                text: "System Prompt saved successfully",
                confirmButtonColor: "#28a745",
            });
        } catch (err) {
            setLoading(false);
            console.error("❌ Error saving prompt:", err);
            Swal.fire({
                icon: "error",
                title: "Save Failed",
                text: "Could not save prompt.",
            });
        }
    };

    return (
        <Fragment>
            <Breadcrumbs mainTitle="Prompt Master" title="Prompt Master" />

            <Card className="mt-3 shadow-lg">
                <div className="d-flex justify-content-between align-items-center p-3 bg-primary text-white rounded-top">
                    <h4 className="mb-0">System Prompt</h4>
                </div>

                <CardBody>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label className="fw-bold">System Prompt</Label>
                                <Input
                                    type="textarea"
                                    rows={10}
                                    value={systemPrompt}
                                    onChange={(e) => setSystemPrompt(e.target.value)}
                                    style={{ minHeight: "400px", fontSize: "1rem", lineHeight: "1.5" }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Sticky Save Button */}
            <div className="text-center mt-3 sticky-bottom bg-white py-3 shadow-sm">
                <Button color="success" size="lg" onClick={handleSave} disabled={loading}>
                    {loading ? "Saving..." : "Save System Prompt"}
                </Button>
            </div>
        </Fragment>
    );
};

export default MappingPromptScreen;
